import type { SignUpFormData } from './types'

export const buildSignupProfileInput = (data: SignUpFormData) => ({
	contactMethods: data.aboutYou.contactMethods,
	whatsappCountryCode: data.aboutYou.whatsappCountryCode || undefined,
	whatsappNumber: data.aboutYou.whatsappNumber || undefined,
	telegramUsername: data.aboutYou.telegramUsername || undefined,
	siteLive: data.aboutBusiness.siteLive,
	monthlyVolume: data.aboutBusiness.monthlyVolume,
	needsProcessing: data.aboutBusiness.needsProcessing,
	currentProcessors: data.aboutBusiness.currentProcessors,
	platforms: data.aboutBusiness.platforms,
	websiteUrl: data.aboutBusiness.websiteUrl || undefined,
})

export const buildAccountName = (data: SignUpFormData) =>
	data.createAccount?.accountName || `${data.aboutYou.firstName}'s account`

export const hasValidSignupData = (data: SignUpFormData): boolean =>
	Boolean(data.aboutYou.firstName && data.aboutYou.email)
